import styled, { css } from 'styled-components';
import { pxToRems } from '@awaze/design-system.components.global-style';
export const StyledDayContainer = styled.div `
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${(p) => (p.largeAmounts ? 'space-between' : 'center')};
  border: 0;
  padding: ${pxToRems(6)} 0 ${pxToRems(4)} 0;

  ${({ theme, isOutOfRange, isActive, isStartOfActiveRange, isEndOfActiveRange, isBookable, isUnselectable, isToday, isHovered, isStartOfHoveredRange, isEndOfHoveredRange, }) => css `
    text-decoration: ${isOutOfRange && !isActive ? 'line-through' : 'none'};
    border-radius: ${isStartOfActiveRange && isEndOfActiveRange
    ? '4px'
    : isStartOfActiveRange
        ? '4px 0 0 4px;'
        : isEndOfActiveRange
            ? '0 4px 4px 0'
            : 'none'};

    ${isToday &&
    css `
      position: relative;
      &:after {
        position: absolute;
        content: '';
        height: 100%;
        width: 100%;
        bottom: 0;
        left: 0;
        border-bottom: 4px solid ${theme.ColorThemePrimary500};
        ${isHovered &&
        ((isStartOfHoveredRange && 'border-radius: 0 0 0 3px') ||
            (isEndOfHoveredRange && 'border-radius: 0 0 3px 0'))}
      }
    `}

    background: ${isStartOfActiveRange || isEndOfActiveRange
    ? theme.ColorComponentCalendarStartEndBackgroundSelected
    : isActive
        ? theme.ColorComponentCalendarBackgroundSelected
        : isBookable
            ? theme.ColorComponentCalendarStartEndBackgroundHover
            : isUnselectable
                ? theme.ColorGrey100
                : 'none'};

    color: ${isOutOfRange && !isActive
    ? theme.ColorGrey300
    : isActive
        ? theme.ColorComponentCalendarTextSelected
        : theme.ColorComponentCalendarText};

    ${isHovered &&
    css `
      box-shadow: inset 0 1px 0 0 ${theme.ColorComponentCalendarBorderHover},
        inset 0 -1px 0 0 ${theme.ColorComponentCalendarBorderHover};
      border-radius: 0;
      background: white;
      color: ${theme.ColorComponentCalendarText};
      cursor: pointer;
    `}

    ${isStartOfHoveredRange &&
    css `
      position: relative;
      color: ${theme.ColorComponentCalendarText};
      border-radius: 4px 0 0 4px;
      box-shadow: inset 1px 0 0 0 ${theme.ColorComponentCalendarBorderHover},
        inset 0 1px 0 0 ${theme.ColorComponentCalendarBorderHover},
        inset 0 -1px 0 0 ${theme.ColorComponentCalendarBorderHover};
      background: ${({ theme }) => theme.ColorComponentCalendarStartEndBackgroundHover};
    `}

    ${isEndOfHoveredRange &&
    css `
      position: relative;
      color: ${theme.ColorComponentCalendarText};
      border-radius: 0 4px 4px 0;
      box-shadow: inset -1px 0 0 0 ${theme.ColorComponentCalendarBorderHover},
        inset 0 1px 0 0 ${theme.ColorComponentCalendarBorderHover},
        inset 0 -1px 0 0 ${theme.ColorComponentCalendarBorderHover};
      background: ${({ theme }) => theme.ColorComponentCalendarStartEndBackgroundHover};
    `}
    
    ${isStartOfHoveredRange &&
    isEndOfHoveredRange &&
    css `
      box-shadow: inset 0 0 0 1px ${theme.ColorComponentCalendarBorderHover},
        inset 0 1px 0 0 ${theme.ColorComponentCalendarBorderHover},
        inset 0 1px 0 0 ${theme.ColorComponentCalendarBorderHover};
      border-radius: 4px;
    `}
  `}
`;
export const PriceWrapper = styled.div `
  padding: 0 ${pxToRems(4)};
`;
//# sourceMappingURL=calendar-day.styles.js.map